import { useMemo } from 'react';

import {
  ButtonIcon,
  IconChevronDown,
  IconChevronUp,
} from '@spotify-internal/encore-web';
import {
  SidebarSectionMui as SidebarSection,
  useDisclosure,
  useDisplayNames,
} from '@spotify/confidence-core-react';

import type { MeasurementConfig } from '../../helpers/time-window';
import { MeasurementInput, QueryPreviewCard } from '../SimplifiedQuery';

type PreviewSectionValue = MeasurementInput & {
  entity?: string | null;
  factTable?: string | null;
  metricWindow?: MeasurementConfig;
};

type PreviewSectionProps = {
  value: PreviewSectionValue;
};

export const PreviewSection = ({ value }: PreviewSectionProps) => {
  const { displayNames } = useDisplayNames();
  const [expanded, { toggle }] = useDisclosure(true);

  const measurement = useMemo<MeasurementInput>(
    () => ({
      typeSpec: value.typeSpec,
      nullHandling: value.nullHandling,
      filter: value.filter,
    }),
    [value.typeSpec, value.nullHandling, value.filter],
  );

  return (
    <SidebarSection.Root>
      <SidebarSection.Header>
        <SidebarSection.Title>Preview</SidebarSection.Title>
        <ButtonIcon
          variant="tertiary"
          size="small"
          aria-label={expanded ? 'Collapse preview' : 'Expand preview'}
          aria-expanded={expanded}
          onClick={toggle}
         data-track-source-anchor="0dc0bc3063;;low">
          {expanded ? <IconChevronUp /> : <IconChevronDown />}
        </ButtonIcon>
      </SidebarSection.Header>
      {expanded && (
        <SidebarSection.Content>
          <QueryPreviewCard
            entity={displayNames.get(value.entity ?? '')}
            factTable={displayNames.get(value.factTable ?? '')}
            measurement={measurement}
            metricWindow={value.metricWindow}
          />
        </SidebarSection.Content>
      )}
    </SidebarSection.Root>
  );
};
